import { allPass } from 'ramda';
import React, { FC, useCallback } from 'react';
import { ItemType } from '../../../../../constants/ItemType';
import { useTrackPreviewActions } from '../../../../../utils/hooks/bi/useTrackPreviewActions';
import { ClickOrigin } from '../../../../../utils/hooks/bi/useTrackPreviewActions/useTrackPreviewActions.types';
import {
  MediaManagerSDKBoard,
  MediaManagerSDKFile,
  MediaManagerSDKFolder,
} from '../../../../../utils/media-manager-sdk';
import { getItemType, isFile, isSiteIconFile } from '../../../../../utils/media-manager-sdk/items';
import { Board } from '../Thumbnails/Board';
import { File } from '../Thumbnails/File';
import { Folder } from '../Thumbnails/Folder';
import styles from './SingleItemTopPart.scss';
import { IOuter } from './SingleItemTopPart.types';

export const SingleItemTopPart: FC<IOuter> = ({ onFilesExpand, item, ...otherProps }) => {
  const { trackPreviewActionsExpandButtonClicked } = useTrackPreviewActions();
  const handleOpenExpandedViewClick = useCallback(() => {
    onFilesExpand();
    trackPreviewActionsExpandButtonClicked(ClickOrigin.MoreInfo);
  }, [onFilesExpand, trackPreviewActionsExpandButtonClicked]);

  const itemType = getItemType(item);

  const shouldKeepOriginalSize = allPass([isFile, isSiteIconFile])(item as MediaManagerSDKFile);

  return (
    <div className={styles.wrapper}>
      {itemType === ItemType.File ? (
        <File
          {...otherProps}
          item={item as MediaManagerSDKFile}
          isPanel
          keepOriginalSize={shouldKeepOriginalSize}
          onFilesExpand={handleOpenExpandedViewClick}
        />
      ) : itemType === ItemType.Folder ? (
        <Folder item={item as MediaManagerSDKFolder} />
      ) : itemType === ItemType.Board ? (
        <Board item={item as MediaManagerSDKBoard} />
      ) : null}
    </div>
  );
};
